import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { Meteor } from 'meteor/meteor';
import { useTracker } from 'meteor/react-meteor-data';
import { LoadingFlex } from '/imports/ui/LoadingFlex';
import { NotPermittedPage } from '/imports/ui/NotPermittedPage';
import { Page } from '/imports/ui/Page';
import { PageBody } from '/imports/ui/PageBody';
import { useFindOne } from '/imports/hooks';
import { Orgs } from '/imports/api/orgs';

const NewSolarBillsPageStyled = styled(Page)`
`;

/** Routes the user to their org-specific solar bills page based on the org sid. */
export const NewSolarBillsPage = () => {
  const currentUser = useTracker(() => Meteor.user());
  if (!currentUser?.isSuperUser) return <NotPermittedPage />;
  if (!currentUser?.orgId) return <NotPermittedPage />;
  const navigate = useNavigate();
  const orgId = currentUser.orgId;
  const org = useFindOne(() => Orgs.find(currentUser.orgId), [orgId]);
  useEffect(() => {
    if (org?.sid === 'dollarGeneral') navigate('/solar-bills/dollar-general');
    if (org?.sid === 'tractorSupply') navigate('/solar-bills/tractor-supply');
    if (org?.sid === 'ultaBeauty') navigate('/solar-bills/ulta-beauty');
    if (org?.sid === 'northshore') navigate('/solar-bills/northshore');
    if (org?.sid === 'calpine') navigate('/solar-bills/calpine');
  }, [org?.sid]);
  return (
    <NewSolarBillsPageStyled>
      <PageBody>
        <LoadingFlex />
      </PageBody>
    </NewSolarBillsPageStyled>
  );
};
